// extracted by mini-css-extract-plugin
export var avatarContainer = "_5k-0";
export var avatarTypingWave = "_5k-i";
export var gray = "_5k-f";
export var green = "_5k-c";
export var icon = "_5k-9";
export var image = "_5k-1";
export var lg = "_5k-6";
export var md = "_5k-5";
export var presenceDot = "_5k-b";
export var red = "_5k-d";
export var sm = "_5k-4";
export var status = "_5k-a";
export var typingDot = "_5k-h";
export var typingPill = "_5k-g";
export var xl = "_5k-7";
export var xs = "_5k-3";
export var xxl = "_5k-8";
export var xxs = "_5k-2";
export var yellow = "_5k-e";